// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_1BiUTiP4","content":"_3ZIp8VAo","title":"e6UFH9Ha","second":"_1eTqTySd","table":"_3fpWIUt9","dadosContainer":"chxAoEk2","error":"_1OCa5YiX","concluded":"_73iXy_3s","submitButton":"_3Wc4ImP7"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/pages/UserWeightPage/UserWeightPage.styl
// module id = 539
// module chunks = 0